<payee-popup [onCancel]="onCancel">
  <ng-template #payeePopupTitleTemplate>
    <h1>{{ "CASES_TABLE.DOWNLOAD_DOCUMENTS_DIALOG.TITLE" | translate }}</h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "CASES_TABLE.DOWNLOAD_DOCUMENTS_DIALOG.DESCRIPTION" | translate }}
    </div>
  </ng-template>

  <div class="dialog-content">
    @if (!counts) {
      <div class="dialog-loading">
        <mat-progress-spinner
          mode="indeterminate"
          diameter="48"
        ></mat-progress-spinner>
      </div>
    }

    @if (counts) {
      @if (!hasAnyDocuments) {
        <p class="no-documents">
          {{ "CASES_TABLE.DOWNLOAD_DOCUMENTS_DIALOG.NO_DOCUMENTS" | translate }}
        </p>
      }
      @if (hasAnyDocuments) {
        <form
          class="options-form"
          [formGroup]="form"
        >
          @if (counts.event_attachment_count > 0) {
            <mat-checkbox
              formControlName="event_attachments"
              color="primary"
            >
              {{ "CASES_TABLE.DOWNLOAD_DOCUMENTS_DIALOG.EVENT_ATTACHMENTS" | translate: { count: counts.event_attachment_count } }}
            </mat-checkbox>
          }
          @if (counts.legal_relationship_contract_count > 0) {
            <mat-checkbox
              formControlName="legal_relationship_contract"
              color="primary"
            >
              {{
                "CASES_TABLE.DOWNLOAD_DOCUMENTS_DIALOG.LEGAL_RELATIONSHIP_CONTRACT"
                  | translate: { count: counts.legal_relationship_contract_count }
              }}
            </mat-checkbox>
          }
          @if (counts.claim_file_count > 0) {
            <mat-checkbox
              formControlName="claim_files"
              color="primary"
            >
              {{ "CASES_TABLE.DOWNLOAD_DOCUMENTS_DIALOG.CLAIM_FILES" | translate: { count: counts.claim_file_count } }}
            </mat-checkbox>
          }
        </form>
      }
    }
  </div>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="!canDownload"
      [loading]="downloading"
      (click)="onDownload()"
    >
      {{ "CASES_TABLE.DOWNLOAD_DOCUMENTS_DIALOG.DOWNLOAD" | translate }}
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      height="normal"
      [isBorderButton]="true"
      [mat-dialog-close]="false"
    >
      {{ "CASES_TABLE.DOWNLOAD_DOCUMENTS_DIALOG.CANCEL" | translate }}
    </button>
  </ng-template>
</payee-popup>
